module.exports = __webpack_public_path__ + "assets/202ebb45b7c207395006c56a93f017a8.svg";